<template>
  <!-- 主页 -->
  <div class="home">
    <!-- bannar+主体 -->
    <div class="bannar">
      <!-- <img src="../../public/img/join/bannar.jpg" /> -->
      <div class="bigtitle">
        <p class="bannerdes1">加入我们</p>
        <p class="bannerdes2">Join us</p>
        <div class="bannaerline"></div>
        <p class="bannerdes3">
          在这里，你会有更高的格局、更开阔的视野和更大的舞台！
        </p>
      </div>
    </div>
    <!-- 人才招聘列表 -->
    <div class="model model1" v-loading="loading1">
      <Minetitle2 :title1="titleArr[0].title1" :title2="titleArr[0].title2" />
      <!-- <img class="model1_bg" src="../../public/img/join/bg_big.jpg" alt="" />\ -->
      <div class="model1_bg"></div>
      <div class="modeltitle">
        <b class="t_part1">职位名称</b>
        <b class="t_part2">工作地点</b>
        <b class="t_part3">招聘人数</b>
        <b class="t_part4">发布时间</b>
      </div>
      <ul class="list_ul">
        <li class="list_li" v-for="(item, index) in data" :key="item.id">
          <div class="list_item1">
            <p class="item_part1">{{ item.positionName }}</p>
            <p class="item_part2">{{ item.workPlace }}</p>
            <p class="item_part3">{{ item.personNum }}</p>
            <p class="item_part4">{{ item.updateTime.slice(0, 10) }}</p>
            <div @click="look_detail(index)" class="btn_look">查看详情</div>
          </div>
          <el-collapse-transition>
            <div class="list_item2" v-show="item.status">
              <Minetitle2
                :title1="titleArr[1].title1"
                :title2="titleArr[1].title2"
              />
              <ul class="detail_arr">
                <li class="detail_item clearfix">
                  <img
                    src="../../public/img/join/icon1.png"
                    alt=""
                    class="detail_icon"
                  />
                  <p class="detail_title">工作地点</p>
                  <p class="detail_context">{{ item.workPlace }}</p>
                </li>
                <li class="detail_item clearfix">
                  <img
                    src="../../public/img/join/icon2.png"
                    alt=""
                    class="detail_icon"
                  />
                  <p class="detail_title">工作经验</p>
                  <p class="detail_context">{{ item.workExperience }}</p>
                </li>

                <li class="detail_item clearfix">
                  <img
                    src="../../public/img/join/icon3.png"
                    alt=""
                    class="detail_icon"
                  />
                  <p class="detail_title">最高学历</p>
                  <p class="detail_context">{{ item.education }}</p>
                </li>

                <li class="detail_item clearfix">
                  <img
                    src="../../public/img/join/icon4.png"
                    alt=""
                    class="detail_icon"
                  />
                  <p class="detail_title">工作类型</p>
                  <p class="detail_context">{{ item.positionType }}</p>
                </li>

                <li class="detail_item clearfix">
                  <img
                    src="../../public/img/join/icon1.png"
                    alt=""
                    class="detail_icon"
                  />
                  <p class="detail_title">招聘人数</p>
                  <p class="detail_context">{{ item.personNum }}</p>
                </li>

                <li class="detail_item clearfix">
                  <img
                    src="../../public/img/join/icon1.png"
                    alt=""
                    class="detail_icon"
                  />
                  <p class="detail_title">发布时间</p>
                  <p class="detail_context">
                    {{ item.updateTime.slice(0, 10) }}
                  </p>
                </li>
              </ul>
              <!-- 描述+要求 -->
              <div class="detail_floor2 clearfix">
                <div class="floor2_item fl">
                  <h3 class="floor2_title">职位描述</h3>
                  <el-input
                    type="textarea"
                    :autosize="false"
                    maxlength="100"
                    resize="none"
                    v-model="item.workDuties"
                  ></el-input>
                </div>
                <div class="floor2_item fr">
                  <h3 class="floor2_title">职位要求</h3>
                  <el-input
                    type="textarea"
                    :autosize="false"
                    maxlength="300"
                    resize="none"
                    v-model="item.workRequire"
                    disabled
                  ></el-input>
                </div>
              </div>
              <!-- 最后 -->
              <div class="detail_final clearfix">
                <p class="detail_final_fl">
                  请将简历投递至邮箱：
                  <b>wefly181223@163.com</b>
                </p>
                <div class="detail_final_fr" @click="close_detail(index)">
                  收起
                  <div class="fr arrow1"></div>
                  <div class="fr arrow2"></div>
                </div>
              </div>
            </div>
          </el-collapse-transition>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import Minetitle2 from "../components/minetitle2.vue";
import { getFunc } from "@/api/home";
import { postPv } from "@/api/postPv";
// @ is an alias to /src
export default {
  name: "aboutus",
  data() {
    return {
      activeName: "item0",
      //题目组
      titleArr: [
        { id: 1, title1: "人才招聘", title2: "Talent recruitment" },
        { id: 2, title1: "职位详情", title2: "Position details" },
      ],
      loading1: true,
      data: [],
      edu: "", //学历
      workType: "", //工作类型
      arr_edu: [], //学历列表
      arr_work: [], //工作类型列表
    };
  },
  watch: {
    // 监控滚动距离和vw
  },
  methods: {
    //展开
    look_detail(index) {
      //切换标题栏跳转
      let that = this;
      that.data.map((item) => {
        item.status = false;
        return item;
      });
      const data = that.data;
      //查一下 然后放进去
      let id_edu = data[index].education,
        id_type = data[index].positionType,
        arr_edu = that.arr_edu,
        arr_work = that.arr_work;

      for (let item of arr_edu) {
        if (id_edu == item.id) {
          data[index].education = item.name;
        }
      }
      for (let item2 of arr_work) {
        if (id_type == item2.id) {
          data[index].positionType = item2.name;
        }
      }

      data[index].status = true;
      that.data = data;
    },
    //收起
    close_detail(index) {
      //切换标题栏跳转
      let that = this;
      const data = that.data;
      data[index].status = false;
      that.data = data;
    },
  },
  mounted() {
    let thiz = this;
    let url1 = "/blade-website/web/menu/recruit/list"; //人才中心
    let url2 = "/blade-system/dict-biz/dictionary?code=edu_claim"; //学历
    let url3 = "/blade-system/dict-biz/dictionary?code=post_type"; //岗位类型
    thiz.$nextTick(() => {
      getFunc(url1)
        .then((res) => {
          if (res.code == 200) {
            const data = res.data.records;
            data.map((item) => {
              item.status = false; //增加一个属性
              return item;
            });
            thiz.data = data;
            thiz.loading1 = false;
          }
        })
        .catch((err) => {
          thiz.loading1 = false;
        });
      getFunc(url2).then((res) => {
        let arr1 = res.data;
        let final = [];
        arr1.map((item) => {
          let obj = {};
          obj.id = item.dictKey;
          obj.name = item.dictValue;
          final.push(obj);
        });
        thiz.arr_edu = final;
      });
      getFunc(url3).then((res) => {
        let arr1 = res.data;
        let final = [];
        arr1.map((item) => {
          let obj = {};
          obj.id = item.dictKey;
          obj.name = item.dictValue;
          final.push(obj);
        });
        thiz.arr_work = final;
      });
      postPv("https://www.azureflying.com/api/blade-website/analytics/access")
        .then((res) => {})
        .catch((err) => {});
      //发送pv
    });
  },
  inject: ["reload"],
  components: { Minetitle2 },
};
</script>
<style scoped>
.home {
  width: 100%;
  overflow-x: hidden;
  padding-top: 80px;
  background: RGBA(231, 232, 232, 1);
}
.bannar {
  width: 100%;
  height: 673px;
  margin-bottom: 89px;
  position: relative;
  background: url("../../public/img/join/bannar.jpg") no-repeat;
  background-size: cover;

  margin-bottom: 40px;
}
/* 公司简介 */
.model {
  width: 80%;
  max-width: 1360px;
  margin: 0 auto;
  position: relative;
}

/* bannar图 */
.bigtitle {
  width: 100%;
  position: absolute;
  left: 0px;
  top: 137px;
  text-align: center;
}
.bannerdes1 {
  font-size: 76px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #ffffff;
  line-height: 72px;
  margin-bottom: 32px;
  letter-spacing: 10px;
}
.bannerdes2 {
  font-size: 40px;
  line-height: 40px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #fff;
  margin-bottom: 60px;
  letter-spacing: 3px;
}
.bannaerline {
  width: 68px;
  height: 6px;
  background: #cccccc;
  margin: 0 auto 41px;
}
.bannerdes3 {
  width: 100%;
  height: auto;
  font-size: 30px;
  font-family: Source Han Sans CN;
  font-weight: 300;
  color: #fff;
  opacity: 0.7;
  letter-spacing: 3px;
}
.model1 {
  height: auto;
  /* min-height: 1427px; */
  max-width: 1820px;
  width: 80%;
  max-width: 9.479167rem;
  margin: 0 15%;
}
.model1_bg {
  width: 100vw;
  height: 100%;
  position: absolute;
  left: -20%;
  top: 0;
  background: url("../../public/img/join/bg_big.jpg") repeat-y;
  background-size: cover;
}
.modeltitle {
  position: relative;
  padding: 0px 0 48px 40px;
}
.modeltitle b {
  display: inline-block;
  font-size: 24px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #999999;
}
.t_part1,
.item_part1 {
  width: 300px;
  margin-right: 99px;
}

.t_part2,
.item_part2 {
  width: 110px;
  margin-right: 138px;
}
.t_part3,
.item_part3 {
  width: 110px;
  margin-right: 138px;
}
.t_part4,
.item_part4 {
  width: auto;
  margin-right: 100px;
}

.list_ul {
  width: 100%;
  height: auto;
  position: relative;
}
.list_li {
  width: 100%;
  height: auto;
  border-top: 1px solid rgba(221, 221, 221, 1);
  padding-left: 40px;
}
.list_item1 {
  width: 100%;
  height: 120px;
}
.btn_look:hover {
  background: #1a64e4;
  color: white;
}
.list_item2 {
  width: 100%;
  height: auto;
}
.list_item1 p {
  height: 120px;
  line-height: 120px;
  display: inline-block;
  font-size: 28px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #333333;
  word-break: keep-all;
}
.btn_look {
  width: auto;
  text-align: center;
  height: 58px;
  line-height: 58px;
  padding: 0 30px;
  background: rgba(88, 158, 248, 0.2);
  border-radius: 6px;
  font-size: 28px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #333333;
  display: inline-block;
}
/* 详情 */
.detail_arr {
  margin-bottom: 20px;
  width: 110%;
  height: auto;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
.detail_item {
  width: 30%;
  height: 28px;
  margin-bottom: 30px;
}
.detail_icon {
  width: 25px;
  height: 25px;
  margin: 2px 6px 1px 0;
  float: left;
}
.detail_title {
  height: 28px;
  line-height: 28px;
  margin-right: 31px;
  font-size: 24px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #999999;
  float: left;
}
.detail_context {
  height: 28px;
  line-height: 28px;
  font-size: 30px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #333333;
  float: left;
}
.detail_floor2 {
  width: 100%;
  height: 622px;
  margin-bottom: 43px;
}
.floor2_item {
  width: 622px;
  height: 100%;
  position: relative;
  background: url("/img/join/bg_ban.png") no-repeat;
  background-size: 100%;
  padding: 50px 30px 30px 30px;
}
.floor2_title {
  font-size: 34px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #524343;
  margin-bottom: 38px;
}

.detail_final {
  width: 100%;
  height: 32px;
  line-height: 32px;
  margin-bottom: 40px;
}
.detail_final_fl {
  float: left;
  height: 32px;
  width: 50%;
  color: #999999;
  font-size: 24px;
}
.detail_final_fl b {
  color: #589ef8;
  font-weight: normal;
}
.detail_final_fr {
  float: right;
  font-size: 24px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #999999;
  line-height: 32px;
  position: relative;
  padding-right: 50px;
}

.arrow1 {
  width: 18px;
  height: 2px;
  background: #999999;
  transform: rotate(45deg);
  position: absolute;
  right: 10px;
  top: 15px;
}
.arrow2 {
  width: 18px;
  height: 2px;
  background: #999999;
  transform: rotate(135deg);
  position: absolute;
  right: 22px;
  top: 15px;
}
</style>
